var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOffers = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#6D6D78"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M9.128 1.572c-.41 0-.814.175-1.077.517L2.03 9.676l-1.34.823H.68c-.432.255-.681.714-.681 1.189 0 .232.066.466.19.683l.96 1.647c.249.439.718.686 1.194.686.227 0 .47-.058.68-.182l.39-.22.952-.538 2.168-.342 7.326-1.151h.008c.16-.03.322-.082.468-.17.447-.26.689-.728.689-1.2 0-.234-.058-.475-.183-.693l-4.528-7.945v-.006c-.08-.13-.183-.27-.322-.38l-.007-.007c-.249-.202-.557-.298-.857-.298",
  transform: "translate(-45 -569) translate(46 570)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.534 13.421l1.312 2.26c.124.218.182.45.182.684 0 .474-.248.933-.688 1.188v-.007l-.344.203v.008c-.212.125-.454.182-.681.182-.476 0-.946-.248-1.194-.691l-1.708-2.945M2.029 9.675L4.366 13.763M12.342 2.131L14.484 0M15.082 4.973L18.404 3.065M16.187 8.754L19.112 7.975",
  transform: "translate(-45 -569) translate(46 570)"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOffers);
export default ForwardRef;